import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";

import ShipmentCalculatorTable from "../../components/ShipmentCalculator/ShipmentCalculatorTable";
import AddShipmentPackage from "../../components/ShipmentCalculator/AddShipmentPackage";



const AddShipPackagePage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                <Breadcrumb title="Shipment Caluclation Management" />
                <AddShipmentPackage/>




            </MasterLayout>
        </>
    );
};

export default AddShipPackagePage;
